import { styled, theme, utils } from 'ui/theme';
import { ButtonAlt } from 'ui/components/primitives/Button';

export const ItemsStyles = {
  Container: styled.div`
    margin: 0 0 ${theme.space[4]};
  `,

  ButtonDelete: styled(ButtonAlt)`
    color: ${theme.colors.build.darkLight};
    justify-self: end;
  `,

  Component: styled.div`
    width: 100%;
  `,

  Content: styled.div`
    display: flex;
    gap: ${theme.space[2]};
  `,

  Details: styled.div`
    ${utils.grid.size[2]};
    gap: ${theme.space[2]};
    width: 100%;
  `,

  Image: styled.span`
    width: ${theme.sizes[12]};

    img {
      border-radius: ${theme.radii.small};
    }
  `,

  QuantitySelector: styled.span`
    justify-self: end;
    max-width: 100px;
  `,

  Title: styled.span`
    display: flex;
    flex-flow: column;
    gap: ${theme.space[1]};

    small {
      font-size: ${theme.fontSizes.xs};
    }

    span {
      ${utils.lineClamp(2)}
      font-size: ${theme.fontSizes.md};
      margin: ${theme.space[0]};
    }
  `,

  Total: styled.span`
    display: flex;
    flex-flow: column;
    gap: ${theme.space[1]};

    small {
      font-size: ${theme.fontSizes.xs};
    }
  `,
};
